import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form, Radio } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const SubjectMasterProvider = (props) => {
  const api = new API();
  const [yearMasterList, setYearMasterList] = useState([]);
  const [addYMPopup, setAddYMPopup] = useState(false);
  const [editYMPopup, setEditYMPopup] = useState(false);
  const [addYMLoader, setAddYMLoader] = useState(false);
  const [deleteYMLoader, setDeleteYMLoader] = useState(false);
  const [updateYMLoader, setUpdateYMLoader] = useState(false);
  const [singleYMID, setSingleYMID] = useState("");
  const [tableFilterYM, setTableFilterYM] = useState({
    name: '',
    page: 1,
    limit: 20,
  });
  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const [loaderYM, setLoaderYM] = useState(false);

  const [TSCatLoader, setTSCatLoader] = useState(false);
  const [TSCatList, setTSCatList] = useState([]);
  const [TSCatTableFilter, setTSCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [TSSubCatLoader, setTSSubCatLoader] = useState(false);
  const [TSSubCatList, setTSSubCatList] = useState([]);
  const [TSSubCatTableFilter, setTSSubCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });

  //exams screen
  const [addTSExamsPopup, setAddTSExamsPopup] = useState(false);
  const [addTSExamsPopupLoader, setAddTSExamsPopupLoader] = useState(false);
  const [addTSExamForm] = Form.useForm();
  const [TSExamTableFilter, setTSExamTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [TSExamList, setTSExamList] = useState([]);
  const [TSExamLoader, setTSExamLoader] = useState(false);
  const [TSAddSectionPopup, setTSAddSectionPopup] = useState(false);
  const [TSEditSectionPopup, setTSEditSectionPopup] = useState(false);
  const [TSExamDeleteLoader, setTSExamDeleteLoader] = useState(false);
  //ts exam section
  const [TSExamSectionListLoader, setTSExamSectionListLoader] = useState(false);
  const [TSExamSectionList, setTSExamSectionList] = useState([]);
  const [TsExamSectionAddLoader, setTsExamSectionAddLoader] = useState(false);
  const [TsExamSectionEditLoader, setTsExamSectionEditLoader] = useState(false);
  const [TSExamSectionAddForm] = Form.useForm();
  const [TSExamSectionEditForm] = Form.useForm();
  const [TSExamSectionDeleteLoader, setTSExamSectionDeleteLoader] = useState(false);
  const [TsFetchSingleSectionLoader, setTsFetchSingleSectionLoader] = useState(false);
  const [TsFetchSingleSectionData, setTsFetchSingleSectionData] = useState({});
  //update exam settings
  const [updateTSExamSettingsLoader, setUpdateTSExamSettingsLoader] = useState(false);
  const [updateTSExamSettingsForm] = Form.useForm();
  const [getSingleExamSettingsLoader, setGetSingleExamSettingsLoader] = useState(false);
  const [getSingleExamSettingsData, setGetSingleExamSettingsData] = useState({});
  //TS Question Page

  const [quesLoadingQMTS, setQuesLoadingQMTS] = useState({
    list: false,
    singleview: false,
    add: false,
    edit: false,
    delete: false,
    row: false,
    uploadexcel: false,
    uploadword: false
  });
  const [formEditQMTS] = Form.useForm();
  const [qmQuestionListTS, setQmQuestionListTS] = useState([]);
  const [qmListViewTS, setQmListViewTS] = useState([]);
  const [viewScreenQMTS, setViewScreenQMTS] = useState({
    add: false,
    edit: false,
    view: false,
    list: true,
    editsnap: false
  });
  const [singleQuestionQMTS, setSingleQuestionQMTS] = useState({});
  const [singleIdQMTS, setSingleIdQMTS] = useState("");
  const [excelFileQMTS, setExcelFileQMTS] = useState(null);
  const [modalQMTS, setModalQMTS] = useState({
    excelupload: false,
    wordupload: false
  });
  const [wordFileQMTS, setWordFileQMTS] = useState(null);
  const [formAddtionalQMTS] = Form.useForm();
  const [getQestionBankQMTS, setGetQestionBankQMTS] = useState({});
  const [rowRefreshQMTS, setRowRefreshQMTS] = useState(false);

  //Attempt List
  const [TSAttemptTableFilter, setTSAttemptTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [TSAttemptList, setTSAttemptList] = useState([]);
  const [TSAttemptListLoader, setTSAttemptListLoader] = useState(false);
  const [TSAttemptDeleteLoader, setTSAttemptDeleteLoader] = useState(false);
  const [TSAttemptDeleteMultipleLoader, setTSAttemptDeleteMultipleLoader] = useState(false);
  const [TsAttemptIds, setTsAttemptIds] = useState([]);
  const [bulkActionTSExam, setBulkActionTSExam] = useState([]);
  const [bulkActionTSExamLoader, setBulkActionTSExamLoader] = useState(false);
  const [bulkActionTSType, setBulkActionTSType] = useState(false);

  const bulkActionTS = async (ids = [], action = null,mid=null) => {
    if (ids.length === 0) return;
    if (!action) return;
    setBulkActionTSExamLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("examsnew/bulk_action_testseries", {
        ids: ids,
        action: action
      }, (err, res) => {
        if (res?.data?.status === 200) {
          mid && fetchTSExamList(mid);
          setBulkActionTSExam([]);
          setBulkActionTSExamLoader(false);
        } else {
          setBulkActionTSExamLoader(false);
        }
      });
  }

  const fetchTSSubCatList = async (id) => {
    setTSSubCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("ts_new/subcategorylist/list", { ...TSSubCatTableFilter, id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setTSSubCatList(res?.data?.data);
          setTSSubCatLoader(false);
        } else {
          setTSSubCatList([]);
          setTSSubCatLoader(false);
        }
      });
  }
  const fetchTSCatList = async () => {
    setTSCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("ts_new/categorylist/list", { ...TSCatTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setTSCatList(res?.data?.data);
          setTSCatLoader(false);
        } else {
          setTSCatList([]);
          setTSCatLoader(false);
        }
      });
  }
  const fetchYM = async (cid, scid) => {
    setLoaderYM(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getAll(
        "ts_new/yearmasterlist",
        { ...tableFilterYM, category_id: cid, subcategory_id: scid },
        (err, res) => {
          if (res?.data?.status === 200) {
            setYearMasterList(res?.data?.data);
          } else {
            setYearMasterList([]);
          }
          setLoaderYM(false);
        }
      );
  };
  const addYM = async (data) => {
    const values = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        values[key] = value;
      }
    });
    setAddYMLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("ts_new/yearmaster", values, (err, res) => {
        if (res?.data?.status === 200) {
          fetchYM(data?.category_id, data?.subcategory_id);
          Widget.showMessage("success", res?.data?.message);
          addForm.resetFields();
          setAddYMPopup(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setAddYMLoader(false);
      }));
  }
  const updateYM = async (data, id, cid, scid) => {
    if (!id) return;
    const values = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        values[key] = value;
      }
    });
    setUpdateYMLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("ts_new/yearmaster", id, values, (err, res) => {
        if (res?.data?.status === 200) {
          fetchYM(cid, scid);
          Widget.showMessage("success", res?.data?.message);
          editForm.resetFields();
          setEditYMPopup(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setUpdateYMLoader(false);
      }));
  }
  //ts exam create init
  const addTSExams = async (data, id = null) => {
    const values = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        values[key] = value;
      }
    });
    setAddTSExamsPopupLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("ts_new/ts_exam_create_init", values, (err, res) => {
        if (res?.data?.status === 200) {
          id && fetchTSExamList(id);
          Widget.showMessage("success", res?.data?.message);
          addTSExamForm.resetFields();
          setAddTSExamsPopup(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setAddTSExamsPopupLoader(false);
      }));
  }
  //ts exam list
  const fetchTSExamList = async (id) => {
    setTSExamLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("ts_new/ts_exam_list", { ...TSExamTableFilter, month_id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setTSExamList(res?.data?.data);
          setTSExamLoader(false);
        } else {
          setTSExamList([]);
          setTSExamLoader(false);
        }
      });
  }

  const currentMonthSwitchChange = async (id,cid,scid) => {
    if(!id) return;
    if(!localStorage.getItem("rxdx_admin_login")) return;
    await api.create("ts_new/update_current_month", {month_id:id}, (err, res)=>{
      if(res?.data?.status===200){
        Widget.showMessage("success", res?.data?.message);
        fetchYM(cid,scid);
      }else{
        Widget.showMessage("error", err?.response?.data?.message);
      }
    });
  }

  // year master delete
  const deleteYearMaster = async (id, cid, scid) => {
    setDeleteYMLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.remove("ts_new/deleteyearmaster", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchYM(cid, scid);
          setDeleteYMLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setDeleteYMLoader(false);
        }
      })
  }

  // ts exam delete
  const deleteTSExam = async (id, mid) => {
    setDeleteYMLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.remove("ts_new/deleteexam", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchTSExamList(mid);
          setDeleteYMLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setDeleteYMLoader(false);
        }
      })
  }

  const addTSExamSection = async (data, exam_id = null) => {
    const values = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        values[key] = value;
      }
    });
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });
    setTsExamSectionAddLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("ts_new/createexamsection", formData, (err, res) => {
        if (res?.data?.status === 200) {
          exam_id && fetchTSExamSection(exam_id);
          Widget.showMessage("success", res?.data?.message);
          TSExamSectionAddForm.resetFields();
          setTSAddSectionPopup(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setTsExamSectionAddLoader(false);
      }));
  }

  const fetchTSExamSection = async (id) => {
    setTSExamSectionListLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("ts_new/getexamsectionlist", { id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setTSExamSectionList(res?.data?.data?.data);
          setTSExamSectionListLoader(false);
        } else {
          setTSExamSectionList([]);
          setTSExamSectionListLoader(false);
        }
      })
  }

  const updateTSExamSection = async (data, exam_id = null) => {
    const values = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        values[key] = value;
      }
    });
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });
    setTsExamSectionEditLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("ts_new/editexamsection", TsFetchSingleSectionData?._id, formData, (err, res) => {
        if (res?.data?.status === 200) {
          exam_id && fetchTSExamSection(exam_id);
          Widget.showMessage("success", res?.data?.message);
          TSExamSectionEditForm.resetFields();
          setTSEditSectionPopup(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setTsExamSectionEditLoader(false);
      }));
  }

  const fetchTSSingleSection = async (id) => {
    setTsFetchSingleSectionLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getSingle("ts_new/getsingleexamsection", id, (err, res) => {
        if (res?.data?.status === 200) {
          setTsFetchSingleSectionData(res?.data?.data);
          TSExamSectionEditForm.setFieldsValue(res?.data?.data);
          setTsFetchSingleSectionLoader(false);
        } else {
          setTsFetchSingleSectionData({});
          setTsFetchSingleSectionLoader(false);
        }
      })
  }

  const deleteTSExamSection = async (id, eid = null) => {
    setTSExamSectionDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.remove("ts_new/deleteexamsection", id, (err, res) => {
        if (res?.data?.status === 200) {
          eid && fetchTSExamSection(eid);
          setTSExamSectionDeleteLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setTSExamSectionDeleteLoader(false);
        }
      })
  }

  const updateTSExamSettings = async (data, exam_id = null) => {
    const values = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        values[key] = value;
      }
    });

    const formData = new FormData();

    const switchFields = [
      "round_off_marks", "enable_rank", "show_score", "show_analystics",
      "show_percentile", "show_pass_or_fail", "allow_retake", "quiz_mode",
      "show_live_tag", "show_schedule_time_enable", "create_confirmation"
    ];

    Object.entries(values).forEach(([key, value]) => {
      if (switchFields.includes(key)) {
        formData.append(key, value ? 1 : 0);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, item);
        });
      } else {
        formData.append(key, value);
      }
    });
    setUpdateTSExamSettingsLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("ts_new/updateexamsettings", exam_id, formData, (err, res) => {
        if (res?.data?.status === 200) {
          fetchTSSingleExamSettings(exam_id);
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setUpdateTSExamSettingsLoader(false);
      }));
  }

  const fetchTSSingleExamSettings = async (id) => {
    const dateFormat = 'YYYY/MM/DD HH:mm:ss';
    setGetSingleExamSettingsLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getSingle("ts_new/getsingleexamsettings", id, (err, res) => {
        if (res?.data?.status === 200) {
          const switch_value = [
            "round_off_marks", "enable_rank", "show_score", "show_analystics",
            "show_percentile", "show_pass_or_fail", "allow_retake", "quiz_mode",
            "show_live_tag", "show_schedule_time_enable", "create_confirmation"
          ];

          setGetSingleExamSettingsData(res?.data?.data);

          const switchValuesObject = switch_value.reduce((acc, key) => {
            acc[key] = Boolean(res?.data?.data?.[key]);
            return acc;
          }, {});

          updateTSExamSettingsForm.setFieldsValue({
            when: res?.data?.data?.when ? dayjs(res?.data?.data?.when) : null,
            to: res?.data?.data?.to ? dayjs(res?.data?.data?.to) : null,
            show_schedule_time: res?.data?.data?.show_schedule_time ? dayjs(res?.data?.data?.show_schedule_time) : null,
            duration_in_minutes: res?.data?.data?.duration_in_minutes,
            pass_persentage: res?.data?.data?.pass_persentage,
            mark_per_question: res?.data?.data?.mark_per_question,
            negative_marks: res?.data?.data?.negative_marks,
            subject: res?.data?.data?.subject,
            tags: res?.data?.data?.tags,
            instruction: res?.data?.data?.instruction,
            exam_display_tab: res?.data?.data?.exam_display_tab,
            ...switchValuesObject
          });

          setGetSingleExamSettingsLoader(false);
        } else {
          setGetSingleExamSettingsLoader(false);
        }
      })
  }

  const addQuestionQMTS = async (data, qid, reSet, sid) => {
    setQuesLoadingQMTS((prev) => ({
      ...prev,
      add: true,
    }))
    const check_correct = data?.question_options?.filter(
      (item) => item?.is_correct === true
    );
    if (check_correct.length < 1) {
      Widget.showMessage("error", "Please select correct option");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        add: false,
      }))
      return;
    }
    if (data?.question_type === "single") {
      if (check_correct.length > 1) {
        Widget.showMessage("error", "Please select single correct option");
        setQuesLoadingQMTS((prev) => ({
          ...prev,
          add: false,
        }))
        return;
      }
    }

    const form_data = new FormData();

    form_data.append("question_name", data.question_name);
    form_data.append("exams_id", qid);
    form_data.append("section_id", sid);
    form_data.append("question_type", data.question_type);
    form_data.append("explanation", data.explanation);
    form_data.append("reference", data.reference);
    form_data.append("hint", data.hint);
    data.question_options.forEach((item, i) => {
      form_data.append(`question_options[${i}][option]`, item.option);
      form_data.append(`question_options[${i}][is_correct]`, Boolean(item.is_correct));
    });

    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("ts_new/addquestion", form_data, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchQMQuestionListTS(qid, sid);
          reSet();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setQuesLoadingQMTS((prev) => ({
          ...prev,
          add: false,
        }))
      }));
  }

  const updateQuestionQMTS = async (data, id, qid, reSetEdit, sid) => {
    setQuesLoadingQMTS((prev) => ({
      ...prev,
      edit: true,
    }))
    const check_correct = data?.question_options?.filter(
      (item) => item?.is_correct === true
    );
    if (check_correct.length < 1) {
      Widget.showMessage("error", "Please select correct option");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        edit: false,
      }))
      return;
    }
    if (data?.question_type === "single") {
      if (check_correct.length > 1) {
        Widget.showMessage("error", "Please select single correct option");
        setQuesLoadingQMTS((prev) => ({
          ...prev,
          edit: false,
        }))
        return;
      }
    }
    const form_data = new FormData();
    form_data.append("question_name", data.question_name);
    form_data.append("question_type", data.question_type);
    form_data.append("explanation", data.explanation);
    form_data.append("reference", data.reference);
    form_data.append("hint", data.hint);
    data.question_options.forEach((item, i) => {
      form_data.append(`question_options[${i}][option]`, item.option);
      form_data.append(`question_options[${i}][is_correct]`, Boolean(item.is_correct));
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.update("ts_new/updatequestion", id, form_data, (err, res) => {
        if (res) {
          formEditQMTS.resetFields();
          // fetchQMQuestionList(qid)
          Widget.showMessage("success", res?.data?.message);
          reSetEdit();
        }
        setQuesLoadingQMTS((prev) => ({
          ...prev,
          edit: false,
        }))
      })
  }

  const fetchQMQuestionListTS = async (qid, sid) => {
    setQuesLoadingQMTS({
      ...quesLoadingQMTS,
      list: true,
    })
    await api.getAll(
      "ts_new/questionlist",
      { exam_id: qid, section_id: sid },
      (err, res) => {

        if (res?.data?.status === 200) {
          const sortedQuestionList = res?.data?.data?.map((q, i) => ({
            key: q?.question_order,
            _id: q?._id,
            name: <div className='d_f g_5'>{q?.question_order}<div dangerouslySetInnerHTML={{ __html: q?.question_name }} onClick={() => getQMSinglrQuestionTS(q?._id, q?.question_order)} style={{ cursor: "pointer" }}></div></div>,
          })).sort((a, b) => a.key - b.key);
          setQmQuestionListTS(sortedQuestionList);
          setQmListViewTS(res?.data?.data?.map((q, i) => ({
            key: q?.question_order,
            _id: q?._id,
            label: <div className='d_f g_5'>{q?.question_order}<div dangerouslySetInnerHTML={{ __html: q?.question_name }}></div></div>,
            children: <div>
              <p className="m_b_10">Answer</p>
              <div className="col_1 g_10">
                {
                  q?.question_options?.map((o, i) => (
                    <div key={i}>
                      <Radio checked={o?.is_correct}><div dangerouslySetInnerHTML={{ __html: o?.option }} /></Radio>
                    </div>
                  ))
                }
              </div>
            </div>,
          })).sort((a, b) => a.key - b.key));
        } else {
          setQmQuestionListTS([]);
        }
        setQuesLoadingQMTS({
          ...quesLoadingQMTS,
          list: false,
        })
      }
    )
  }

  const scrollToTopViewTS = (index) => {
    document.getElementById(`question_order_${index}`).scrollIntoView({ top: 0, behavior: 'smooth' });
  }

  const getQMSinglrQuestionTS = async (id, order) => {
    if (viewScreenQMTS.editsnap === false) {
      scrollToTopViewTS(order);
      return;
    }
    setViewScreenQMTS({
      ...viewScreenQMTS,
      add: false,
      edit: false,
      view: true
    });
    setQuesLoadingQMTS({
      ...quesLoadingQMTS,
      singleview: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getSingle(
        'ts_new/single/question',
        id,
        (err, res) => {
          if (res?.data?.status === 200) {
            setSingleQuestionQMTS(res?.data?.data);
            setSingleIdQMTS(res?.data?.data?._id);
            formEditQMTS.setFieldsValue(res?.data?.data);
          }
          setQuesLoadingQMTS({
            ...quesLoadingQMTS,
            singleview: false
          })
        }
      ))
  }

  const rowUpdateQMTS = async (newData = [], qid, sid) => {
    setQuesLoadingQMTS((prev) => ({
      ...prev,
      row: true,
    }))
    const updateData = [];
    newData?.map((d, i) => {
      updateData.push({
        _id: d?._id,
        question_order: i + 1
      })
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.create("ts_new/questionlist/rowupdate", { row: updateData }, (err, res) => {
        if (res?.data?.status === 200) {
          fetchQMQuestionListTS(qid, sid)
        }
        setQuesLoadingQMTS((prev) => ({
          ...prev,
          row: false,
        }))
      });
  }

  const questionDeleteQMTS = async (id, qid, reSetEdit, sid) => {
    setQuesLoadingQMTS((prev) => ({
      ...prev,
      delete: true,
    }))
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.remove("ts_new/delete", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchQMQuestionListTS(qid, sid)
          reSetEdit();
        }
        setViewScreenQMTS({
          ...viewScreenQMTS,
          view: false,
          list: true,
        })
        formEditQMTS.resetFields();
        setQuesLoadingQMTS((prev) => ({
          ...prev,
          delete: false,
        }))

      });
  }

  const bulkUploadExcelQMTS = async (qid, sid) => {
    setQuesLoadingQMTS((prev) => ({
      ...prev,
      uploadexcel: true,
    }))
    if (!excelFileQMTS) {
      Widget.showMessage("error", "Please select excel file");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
      return;
    }
    if (!qid) {
      Widget.showMessage("error", "Please select question bank");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
      return;
    }
    if (!sid) {
      Widget.showMessage("error", "Please select subject");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
      return;
    }
    const formData = new FormData();
    formData.append("file", excelFileQMTS);
    formData.append("exams_id", qid);
    formData.append("section_id", sid);
    await api.create("ts_new/bulkupload", formData, (err, res) => {
      if (res?.data?.status === 200) {
        fetchQMQuestionListTS(qid, sid)
        setExcelFileQMTS(null)
        document.getElementById("excelFile").value = "";
        setModalQMTS({ ...modalQMTS, excelupload: false })
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
    })
  }

  const bulkUploadWordQMTS = async (qid, sid) => {
    setQuesLoadingQMTS((prev) => ({
      ...prev,
      uploadword: true,
    }))
    if (!wordFileQMTS) {
      Widget.showMessage("error", "Please select word file");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadword: false,
      }))
      return;
    }
    if (!qid) {
      Widget.showMessage("error", "Please select question bank");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadword: false,
      }))
      return;
    }
    if (!sid) {
      Widget.showMessage("error", "Please select subject");
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadword: false,
      }))
      return;
    }
    //bulkuploadwordnew
    const formData = new FormData();
    formData.append("file", wordFileQMTS);
    formData.append("exams_id", qid);
    formData.append("section_id", sid);
    await api.create("ts_new/bulk_upload_word", formData, (err, res) => {
      if (res?.data?.status === 200) {
        fetchQMQuestionListTS(qid, sid)
        setWordFileQMTS(null)
        document.getElementById("excelFile1").value = "";
        setModalQMTS({ ...modalQMTS, wordupload: false })
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setQuesLoadingQMTS((prev) => ({
        ...prev,
        uploadword: false,
      }))
    })
  }

  const fetchSingleQuestionBankQMTS = async (id) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getSingle(
        `questionbanknew/single`,
        id,
        (err, res) => {
          if (res?.data?.status === 200) {
            setGetQestionBankQMTS(res?.data?.data);
            formAddtionalQMTS.setFieldsValue(res?.data?.data)
          } else {
            setGetQestionBankQMTS({});
          }
        }
      );
  }

  const fetchTSExamAttemptList = async (id) => {
    setTSAttemptListLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("ts_new/attempt_list", { ...TSAttemptTableFilter, exams_id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setTSAttemptList(res?.data?.data);
          setTSAttemptListLoader(false);
        } else {
          setTSAttemptList([]);
          setTSAttemptListLoader(false);
        }
      });
  }

  const deleteTSExamAttemptList = async (id, type,action) => {
    if (type = "single") {
      setTSAttemptDeleteLoader(true);
    } else {
      setTSAttemptDeleteMultipleLoader(true);
    }
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("ts_new/delete_attempt",{
        ids:type==="single" ? [action] : TsAttemptIds
      }, (err, res) => {
        if (res?.data?.status === 200) {
          if (type = "single") {
            setTSAttemptDeleteLoader(false);
          } else {
            setTSAttemptDeleteMultipleLoader(false);
          }
          setTsAttemptIds([]);
          fetchTSExamAttemptList(id)
        } else {
          if (type = "single") {
            setTSAttemptDeleteLoader(false);
          } else {
            setTSAttemptDeleteMultipleLoader(false);
          }
        }
      });
  }

  return (
    <Context.Provider
      value={{
        ...props,
        fetchYM,
        loaderYM,
        yearMasterList, setYearMasterList,
        tableFilterYM, setTableFilterYM,
        addYMPopup, setAddYMPopup,
        editYMPopup, setEditYMPopup,
        addYMLoader, setAddYMLoader,
        addYM,
        addForm,
        editForm,
        updateYM,
        updateYMLoader, setUpdateYMLoader,
        singleYMID, setSingleYMID,
        fetchTSSubCatList,
        fetchTSCatList,
        TSCatLoader, setTSCatLoader,
        TSCatList, setTSCatList,
        TSCatTableFilter, setTSCatTableFilter,
        TSSubCatLoader, setTSSubCatLoader,
        TSSubCatList, setTSSubCatList,
        TSSubCatTableFilter, setTSSubCatTableFilter,
        //exam screen
        addTSExamsPopup, setAddTSExamsPopup,
        addTSExamsPopupLoader, setAddTSExamsPopupLoader,
        addTSExamForm,
        addTSExams,
        fetchTSExamList,
        TSExamTableFilter, setTSExamTableFilter,
        TSExamList, setTSExamList,
        TSExamLoader, setTSExamLoader,
        TSAddSectionPopup, setTSAddSectionPopup,
        TSEditSectionPopup, setTSEditSectionPopup,
        deleteYMLoader, setDeleteYMLoader,
        deleteYearMaster,
        TSExamDeleteLoader, setTSExamDeleteLoader,
        deleteTSExam,
        TSExamSectionListLoader, setTSExamSectionListLoader,
        TSExamSectionList, setTSExamSectionList,
        TsExamSectionAddLoader, setTsExamSectionAddLoader,
        TsExamSectionEditLoader, setTsExamSectionEditLoader,
        TSExamSectionAddForm,
        TSExamSectionEditForm,
        TsFetchSingleSectionLoader, setTsFetchSingleSectionLoader,
        TsFetchSingleSectionData, setTsFetchSingleSectionData,
        TSExamSectionDeleteLoader, setTSExamSectionDeleteLoader,
        addTSExamSection,
        fetchTSExamSection,
        updateTSExamSection,
        fetchTSSingleSection,
        deleteTSExamSection,
        updateTSExamSettingsLoader, setUpdateTSExamSettingsLoader,
        updateTSExamSettingsForm,
        getSingleExamSettingsLoader, setGetSingleExamSettingsLoader,
        getSingleExamSettingsData, setGetSingleExamSettingsData,
        updateTSExamSettings,
        fetchTSSingleExamSettings,
        //ts question page
        quesLoadingQMTS, setQuesLoadingQMTS,
        addQuestionQMTS,
        updateQuestionQMTS,
        formEditQMTS,
        qmQuestionListTS, setQmQuestionListTS,
        qmListViewTS, setQmListViewTS,
        viewScreenQMTS, setViewScreenQMTS,
        singleQuestionQMTS, setSingleQuestionQMTS,
        singleIdQMTS, setSingleIdQMTS,
        excelFileQMTS, setExcelFileQMTS,
        modalQMTS, setModalQMTS,
        wordFileQMTS, setWordFileQMTS,
        fetchQMQuestionListTS,
        scrollToTopViewTS,
        getQMSinglrQuestionTS,
        rowUpdateQMTS,
        questionDeleteQMTS,
        bulkUploadExcelQMTS,
        bulkUploadWordQMTS,
        formAddtionalQMTS,
        fetchSingleQuestionBankQMTS,
        getQestionBankQMTS, setGetQestionBankQMTS,
        rowRefreshQMTS, setRowRefreshQMTS,
        //attempt
        fetchTSExamAttemptList,
        TSAttemptTableFilter, setTSAttemptTableFilter,
        TSAttemptList, setTSAttemptList,
        TSAttemptListLoader, setTSAttemptListLoader,
        deleteTSExamAttemptList,
        TSAttemptDeleteLoader, setTSAttemptDeleteLoader,
        TsAttemptIds, setTsAttemptIds,
        TSAttemptDeleteMultipleLoader, setTSAttemptDeleteMultipleLoader,

        bulkActionTS,
        bulkActionTSExam, setBulkActionTSExam,
        bulkActionTSExamLoader, setBulkActionTSExamLoader,
        bulkActionTSType, setBulkActionTSType,
        currentMonthSwitchChange,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default SubjectMasterProvider;
